import { render, staticRenderFns } from "./CatalogosIngredientes.vue?vue&type=template&id=691dc872&"
import script from "./CatalogosIngredientes.vue?vue&type=script&lang=js&"
export * from "./CatalogosIngredientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports